<h1 class="accessibility-only">Badges</h1>

<ng-container *ifScreenSize="screenType.Desktop">
  <div class="banner" role="banner"></div>
</ng-container>

<ng-container *ifScreenSize="screenType.Mobile">
  <div class="container px-0">
    <fgb-barcode [isWalletPage]="false" [showBarcode]="true"></fgb-barcode>
  </div>
</ng-container>

<!--Account Nav-->
<fgb-account-nav></fgb-account-nav>

<fgbcl-badge-achieved></fgbcl-badge-achieved>

<!--Scorecard carousel-->
<div class="mt-4">
  <fgbcl-scorecard-list-view
    [isSponsorInBody]="false"
    [icon]="'chevron_right'"
    [showPlaceholder]="true"
  ></fgbcl-scorecard-list-view>
</div>
